import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import type { PermissionCatalogFetchedAction } from '@Application/Security/Roles/Actions/permissionCatalogFetched';
import PermissionCatalogView from '@UI/Store/PermissionCatalog/Views/PermissionCatalogView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type PermissionCatalogStore = {
	catalog: PermissionCatalogView | null;
};

const initialState: PermissionCatalogStore = {
	catalog: null,
};

type Actions = PermissionCatalogFetchedAction | UserRevokedAction;

const whenPermissionCatalogFetched = (
	store: PermissionCatalogStore,
	action: PermissionCatalogFetchedAction,
): PermissionCatalogStore => ({
	...store,
	catalog: new PermissionCatalogView(action.payload),
});

const whenUserRevoked = (): PermissionCatalogStore => initialState;

export default registerStore<'permissionCatalogStore', Actions>(
	'permissionCatalogStore',
	createSliceReducer({
		PERMISSION_CATALOG_FETCHED: whenPermissionCatalogFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
